import { HTTP } from '@/api';

export default {
  getAds({ commit }) {
    return HTTP.get('/ads').then((res) => {
      if (res.data && res.data.success) {
        commit('ads', res.data.result);
      }
    });
  },
  saveAd({ commit }, data) {
    return HTTP.post('/ads', data).then((res) => {
      if (res.data && res.data.success) {
        commit('addAd', res.data.result);
      }
    });
  },
  updateAd({ commit }, { _id, data }) {
    return HTTP.post(`/ads/${_id}`, data).then((res) => {
      if (res.data && res.data.success) {
        commit('updateAd', res.data.result);
      }
    });
  },
  removeAd({ commit }, _id) {
    return HTTP.delete(`/ads/${_id}`).then((res) => {
      if (res.data && res.data.success) {
        commit('removeAd', _id);
      }
    });
  },
};
